import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Sponsors from './Sponsors';

import nte from '../../../img/logos/nte.svg';
import atrium from '../../../img/logos/atrium.svg';

import styles from '../../../styles/partials/logos.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const LogosPartial = ({ className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <a href="https://nte.qc.ca/" target="_blank" rel="noopener noreferrer">
                <img
                    className={classNames([styles.logo, styles.nte])}
                    src={nte}
                    alt="Nouveau Théâtre Expérimental"
                />
            </a>
            <a href="https://tropiques-atrium.fr/" target="_blank" rel="noopener noreferrer">
                <img
                    className={classNames([styles.logo, styles.atrium])}
                    src={atrium}
                    alt="Tropiques-Atrium"
                />
            </a>
            <Sponsors />
        </div>
    );
};

LogosPartial.propTypes = propTypes;
LogosPartial.defaultProps = defaultProps;

export default LogosPartial;
